import { Component, OnInit } from '@angular/core';
import { ReportsService } from 'src/app/services/data/reports-service.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  currentCategory: string = 'technical';
  currentReportType: string = 'daily';
  reportsData: any[] = [];
  reportsPage: number = 1;

  constructor(private reportsService: ReportsService) {}

  ngOnInit(): void {
    this.loadReports();
  }

  changeCategory(category: string): void {
    this.currentCategory = category;
    this.currentReportType = 'daily';
    this.reportsPage = 1;
    this.loadReports();
  }

  changeReportType(type: string): void {
    this.currentReportType = type;
    this.reportsPage = 1;
    this.loadReports();
  }

  private get combinedReportType(): string {
    return `${this.currentCategory}-${this.currentReportType}`;
  }

  loadReports(): void {
    this.reportsService.getReports(this.combinedReportType).subscribe(data => {
      this.reportsData = data;
    });
  }

  downloadFile(fileName: string): void {
    this.reportsService.downloadReportFile(fileName, this.combinedReportType).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    });
  }
}
